<div class="history-panel">

  <!-- Estado vacío -->
  <div *ngIf="historyList.length === 0 && !restoring" class="history-empty">
    <i class="pi pi-history history-empty-icon"></i>
    <p>{{ 'FASCICLE.HISTORY_EMPTY' | translate }}</p>
  </div>

  <!-- Lista de snapshots -->
  <ul class="history-list" *ngIf="historyList.length > 0">
    <li *ngFor="let snap of historyList" class="history-item">
      <div class="history-item-info">
        <i [class]="opIcons[snap.operationType]" class="history-op-icon"></i>
        <div class="history-item-meta">
          <span class="history-op-label">{{ opLabelKeys[snap.operationType] | translate }}</span>
          <span class="history-item-date">{{ snap.createdAt | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
          <span *ngIf="snap.createdBy" class="history-item-user">
            {{ snap.createdBy.name }} {{ snap.createdBy.surname }}
          </span>
        </div>
      </div>

      <!-- Confirmación inline -->
      <div *ngIf="confirmingId === snap._id; else restoreBtn" class="history-confirm">
        <small>{{ 'FASCICLE.HISTORY_RESTORE_CONFIRM' | translate }}</small>
        <div class="flex gap-2 mt-2">
          <p-button
            label="{{ 'FORM.YES' | translate }}"
            icon="pi pi-check"
            severity="warning"
            [size]="'small'"
            [loading]="restoring"
            (onClick)="restore(snap._id)"
          />
          <p-button
            label="{{ 'FORM.NO' | translate }}"
            icon="pi pi-times"
            severity="secondary"
            [outlined]="true"
            [size]="'small'"
            (onClick)="cancelConfirm()"
          />
        </div>
      </div>

      <ng-template #restoreBtn>
        <p-button
          icon="pi pi-undo"
          [title]="'FASCICLE.HISTORY_RESTORE' | translate"
          severity="secondary"
          [outlined]="true"
          [size]="'small'"
          [disabled]="restoring"
          (onClick)="confirmRestore(snap._id)"
        />
      </ng-template>
    </li>
  </ul>

  <!-- Spinner restaurando -->
  <div *ngIf="restoring" class="history-restoring">
    <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="4" />
  </div>

</div>
